import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@elparking/components'

import BookingProduct from 'parking-availability/js/components/BookingProduct'
import { BookingProductType } from 'parking-availability/js/propTypes'

import isBookingProductEqual from './isBookingProductEqual'

class BookingProductsList extends PureComponent {
    static propTypes = {
        selectedBookingProduct: BookingProductType,
        bookingProducts: PropTypes.arrayOf(BookingProductType).isRequired,
        isDisabled: PropTypes.bool,
        onClick: PropTypes.func,
    }

    static defaultProps = {
        onClick: () => {},
    }

    renderItem (bookingProduct) {
        const { selectedBookingProduct, isDisabled } = this.props

        return (
            <BookingProduct
              bookingProduct={bookingProduct}
              isSelected={isBookingProductEqual(selectedBookingProduct, bookingProduct)}
              isDisabled={isDisabled}
            />
        )
    }

    render () {
        const { bookingProducts, isDisabled } = this.props

        return (
            <Box as='ul'>
                {bookingProducts.map((bookingProduct, index) => (
                    <Box
                      as='li'
                      key={bookingProduct.product.id}
                      w='100%'
                      mb={index < bookingProducts.length - 1 ? '1em' : '0'}
                      style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                      onClick={() => this.props.onClick(bookingProduct)}
                    >
                        {this.renderItem(bookingProduct)}
                    </Box>
                ))}
            </Box>
        )
    }
}

export default BookingProductsList
